import * as tslib_1 from "tslib";
import { CaptureService } from '../capture/capture.service';
import { ProductLoaderService } from '../product-loader/product-loader.service';
import { CopyService } from '../copies/copy.service';
import { ParametersService } from '../parameters/parameters.service';
import { OpEnum } from '../../enums/op.enum';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { BioCatchService } from '../external/biocatch/biocatch.service';
import { StepBiocatchEnum } from '../../enums/biocatchContext.enum';
import * as i0 from "@angular/core";
import * as i1 from "../capture/capture.service";
import * as i2 from "../product-loader/product-loader.service";
import * as i3 from "../copies/copy.service";
import * as i4 from "../parameters/parameters.service";
import * as i5 from "../abre-cuentas/abre-cuentas.service";
import * as i6 from "../external/biocatch/biocatch.service";
var PreValidateService = /** @class */ (function () {
    function PreValidateService(captureService, productLoaderService, copyService, parametersService, abreCuentasService, bioCatchService) {
        this.captureService = captureService;
        this.productLoaderService = productLoaderService;
        this.copyService = copyService;
        this.parametersService = parametersService;
        this.abreCuentasService = abreCuentasService;
        this.bioCatchService = bioCatchService;
    }
    PreValidateService.prototype.switchFunction = function (func) {
        switch (func) {
            case 'preCreateFinancial':
                return this.preCreateFinancial();
            case 'showLoadingPCO':
                return this.showLoading();
            case 'hideLoading':
                return this.hideLoading();
            case 'preIncomes':
                return this.Incomes();
            case 'prospectAddressesParticular':
                return this.prospectAddresses('PARTICULAR');
            case 'prospectAddressesLaboral':
                return this.prospectAddresses('LABORAL');
            case 'prospectAddressesCardSend':
                return this.prospectAddresses('CARD_SEND');
            case 'prospectAddresses':
                return this.prospectAddresses('DEFAULT');
            case 'getPcoAmount':
                return this.getPcoAmount();
            case 'createContactInfoParticular':
                return this.createContactInfo('PARTICULAR');
            case 'createContactInfoLaboral':
                return this.createContactInfo('LABORAL');
            case 'prospectOccupation':
                return this.prospectOccupation();
            case 'createClient':
                return this.createClient();
            case 'initBioCatch':
                return this.initBioCatch();
            default:
                break;
        }
    };
    PreValidateService.prototype.createClient = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService.createClient()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, '200'];
                }
            });
        });
    };
    PreValidateService.prototype.showLoading = function () {
        this.productLoaderService.show(this.copyService.copies.show_load_pco, this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO']);
        return '200';
    };
    PreValidateService.prototype.hideLoading = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.productLoaderService.hide()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, '200'];
                }
            });
        });
    };
    PreValidateService.prototype.preCreateFinancial = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService.createFinancials().then(function () {
                            try {
                                _this.code = '200';
                            }
                            catch (error) {
                                _this.code = '500';
                            }
                        }, function () {
                            _this.code = '500';
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    PreValidateService.prototype.prospectAddresses = function (type) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService.prospectAddresses(type)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, '200'];
                }
            });
        });
    };
    PreValidateService.prototype.createContactInfo = function (type) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService.createContactInfo(type).then(function () {
                            try {
                                _this.code = '200';
                            }
                            catch (error) {
                                _this.code = '500';
                            }
                        }, function () {
                            return _this.code = '500';
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    PreValidateService.prototype.Incomes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService.performIncomes().then(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                if (res !== '200') {
                                    this.code = '500';
                                }
                                this.code = '200';
                                return [2 /*return*/];
                            });
                        }); }).catch(function () { _this.code = '500'; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    PreValidateService.prototype.prospectOccupation = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService
                            .sendProspectOccupation()
                            .then(function (res) {
                            if (res) {
                                console.log('aqui');
                                _this.abreCuentasService.setinfoInferredIncomes(res.body.data);
                                console.log('aqui2');
                                if (!res.status || res.status === 500) {
                                    _this.code = '500';
                                }
                                else if (res.status !== 200) {
                                    var codigo = res.body.data.codigo;
                                    switch (codigo) {
                                        case '422-06':
                                            _this.code = '106';
                                            break;
                                        case '422-07':
                                            _this.code = '106';
                                            break;
                                        case '400':
                                            _this.code = '500';
                                            break;
                                    }
                                }
                                else if (res.body.data.income_amount.amount === 0) {
                                    _this.code = '106';
                                }
                                else {
                                    _this.code = '000';
                                }
                            }
                            else {
                                _this.code = '500';
                            }
                        })
                            .catch(function () {
                            return _this.code = '500';
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    PreValidateService.prototype.getPcoAmount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService.getPcoAmount().then(function (data) { _this.code = data; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    PreValidateService.prototype.initBioCatch = function () {
        var product = this.abreCuentasService.getproductSelected().product_code;
        this.bioCatchService.changeContext(StepBiocatchEnum.captura, product);
        return '200';
    };
    PreValidateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PreValidateService_Factory() { return new PreValidateService(i0.ɵɵinject(i1.CaptureService), i0.ɵɵinject(i2.ProductLoaderService), i0.ɵɵinject(i3.CopyService), i0.ɵɵinject(i4.ParametersService), i0.ɵɵinject(i5.AbreCuentasService), i0.ɵɵinject(i6.BioCatchService)); }, token: PreValidateService, providedIn: "root" });
    return PreValidateService;
}());
export { PreValidateService };
